import { useMutation } from "@apollo/client";
import gql from "graphql-tag";
import { useState } from "react";
import { NewsletterErrors } from "../components/SemanticTheme/Footer";

const NEWSLETTER_SIGNUP = gql`
  mutation NewsletterSignup($request: NewsletterSignupRequestInput!) {
    newsletterSignup(request: $request) {
      ... on NewsletterSignupResponse {
        success
      }
      ... on NewsletterSignupError {
        errorFields
        message
      }
    }
  }
`;

export default function useNewsLetterSignUpService() {
  const [errors, setErrors] = useState<NewsletterErrors[]>([]);
  const [success, setSuccess] = useState(false);
  const [newsletterSignUp, { called, loading, error }] = useMutation(
    NEWSLETTER_SIGNUP,
    {
      onCompleted: (data) => {
        if (data.newsletterSignup) {
          if (data.newsletterSignup.success) {
            setSuccess(true);
          } else {
            const errorMessages = data.newsletterSignup.message.split(", ");

            setErrors(
              data.newsletterSignup.errorFields.map(
                (field: string, idx: number) => ({
                  errorField: field,
                  errorMessage: errorMessages[idx],
                })
              )
            );
            setSuccess(false);
          }
        }
      },
      onError: (error) => console.log("error", error.message),
    }
  );

  return {
    newsletterSignUp,
    called,
    errors,
    success,
    loading,
    error,
  };
}
